import AccentTable from '@assets/icons/accent-table.svg';
import typography from '~styles/typography.scss';
import styles from './ComingSoon.scss';

export const ComingSoon = () => (
  <div className={styles.container}>
    <AccentTable role="presentation" />
    <h2 className={typography.d3}>Coming Soon</h2>
    <p className={typography.c2}>
      This restaurant is not yet available on Peak but check back&nbsp;soon!{' '}
    </p>
  </div>
);
